export function isAuthenticated() {
  const token = localStorage.getItem('accessToken');
  // You could add additional logic to check the token's expiration if included in the payload
  return !!token;
}
